const fetchProductsSimilars = async (product_ids) => {
  try {
    const baseURL =
      "https://mealz.ca/api/shop-products-similars?product_ids=" + product_ids;
    const res = await fetch(baseURL);
    if (res.ok) {
      const data = await res.json();
      console.log({ data });
      return data.data;
    } else {
      throw new Error(res.statusText);
    }
  } catch (e) {
    console.error(e);
  }
};

const getSimilarProduct = async (products_list, number_of_weeks) => {
  try {
    if (!products_list || products_list.constructor !== Array) {
      throw new Error("product_IDS must be an array");
    }
    const queryProducts = products_list.map((product) => product.id);
    const weeks = {};
    const response = await fetchProductsSimilars(queryProducts);


    if (response.length > 0) {
      for (const item of response) {
        const original_product = products_list.filter(
          (p) => p.id == item.product_id
        )[0];
        const category = original_product.category;
        if (item.similars.length > 0) {
          item.similars.forEach((prod) => {
            prod.available_weeks.forEach((week) => {
              if (weeks[week] === undefined) {
                weeks[week] = [];
              }
              weeks[week].push({ ...prod.variants[0], category });
            });
          });
        } else {
          const product = products_list.filter(
            (p) => p.id == item.product_id
          )[0];
          for (i = 1; i <= 8; i++) {
            if (weeks[i] === undefined) {
              weeks[i] = [];
            }
            weeks[i].push({ ...product.json, category: product.category });
          }
        }
      }
      return weeks;
    } else {
      throw new Error("Data not received from server");
    }
  } catch (e) {
    console.error(e);
  }
};

const fetchProductDetail = async function (handle) {
  const res = await fetch("/products/" + handle + ".js");
  const data = await res.json();
  return data;
};
